import Payment from './models'

export default Payment
